import Utils from "./util";
import { useUserStore } from "@/stores/modules/user"; // 导入用户 store
import eventBus from "@/utils/eventBus"; // 导入事件总线

class WebSocketClient {
  constructor() {
    this.ws = null;
    this.heartbeatInterval = 2000; // 心跳间隔时间
    this.heartbeatObj = null; // 心跳定时器
    this.serverHeartbeatObj = null; // 服务端心跳定时器
    this.serverHeartbeatInterval = 2000; // 服务端心跳间隔时间
    this.reconnectInterval = 2000; // 重连间隔时间
    this.reconnectAttempts = 0; // 重连次数
    this.reconnectObj = null; // 重连定时器
    this.isConnecting = false; // 新增标志，指示是否正在连接
    this.lockReconnect = false; // 新增标志，指示是否锁定重连
    this.isManuallyClosed = false; //是否主动关闭
  }

  connect() {
    if (this.isConnecting) return; // 如果正在连接，直接返回
    this.isConnecting = true; // 设置为正在连接状态
    const token = Utils.$storageGet("token");
    if (!token) {
      this.isConnecting = false; // 如果没有token，重置状态
      this.isManuallyClosed = true; // 设置为主动关闭
      return;
    }
    try {
      // console.log("websocket 正在链接");
      this.ws = new WebSocket(`wss://pg028-api.centuries.cc/ws`);//43.136.50.225
      this.ws.onopen = this.handleOpen;
      this.ws.onmessage = this.handleMessage;
      this.ws.onclose = this.handleClose;
      this.ws.onerror = this.handleError;
    } catch (error) {
      console.error("Failed to connect to WebSocket:", error);
    } finally {
      this.isConnecting = false;
      this.lockReconnect = false;
    }
  }

  handleOpen = () => {
    // console.log("WebSocket连接成功");
    this.reconnectAttempts = 0; // 重置重连次数
    this.isManuallyClosed = false; // 设置为非主动关闭
    this.ws.send(
      JSON.stringify({
        cmd: 0x4000,
        token: Utils.$storageGet("token"),
      })
    );
  };

  startHeartbeat() {
    this.heartbeatObj && clearInterval(this.heartbeatObj);
    this.serverHeartbeatObj && clearTimeout(this.serverHeartbeatObj);
    this.heartbeatObj = setTimeout(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(
          JSON.stringify({
            cmd: 0x3001,
            type: "heartbeat",
            token: Utils.$storageGet("token"),
          })
        );
      } else {
        console.log("websocket 心跳断开");
        this.handleReconnect();
      }
      this.serverHeartbeatObj = setTimeout(() => {
        console.log("websocket 心跳超时");
        this.ws.close();
        this.handleReconnect();
      }, this.serverHeartbeatInterval);
    }, this.heartbeatInterval);
  }

  resetHeartbeat() {
    clearTimeout(this.heartbeatObj);
    clearTimeout(this.serverHeartbeatObj);
    //重启心跳
    this.startHeartbeat();
  }

  handleMessage = (event) => {
    try {
      const msgData = JSON.parse(event.data);
      // console.log("websocket 接收数据", msgData);
      const userStore = useUserStore(); // 获取用户 store
      // console.log("接收消息到:",msgData)
      switch (msgData.cmd) {
        case 0x4000:
          // console.log(
          //   "websocket 认证成功",
          //   Math.floor(new Date().getTime() / 1000)
          // );
          this.startHeartbeat();
          break;
        case 0x3001:
          // console.log(
          //   "websocket 心跳成功",
          //   Math.floor(new Date().getTime() / 1000)
          // );
          this.resetHeartbeat();
          break;
        case 0x2001:
          console.log(
            "websocket 金币变化成功",
            Math.floor(new Date().getTime() / 1000)
          );
          userStore.setCoin(message.data.current); // 使用 store 的方法
          userStore.getUserinfo();
          userStore.getVipLevelList();
          break;
        case 0x2002:
          console.log(
            "websocket 邮件通知成功",
            Math.floor(new Date().getTime() / 1000)
          );
          userStore.getNotificationList();
          break;
        case 0x2003:
          console.log("踢出用户成功", Math.floor(new Date().getTime() / 1000));
          eventBus.emit("kick_user");
          break;
        case 0x2004:
          console.log("token过期", Math.floor(new Date().getTime() / 1000));
          userStore.logout();
          break;
        case 0x3006: // 游戏限制通知
          // console.log("websocket 游戏限制通知", msgData);
          eventBus.emit("game_restriction_notify", msgData);
          break;
        default:
          console.log("websocket 接收未处理消息", msgData);
          break;
      }
    } catch (error) {
      // console.error("websocket 解析数据错误:", error);
      this.handleReconnect();
    }
  };

  handleClose = (error) => {
    console.log("websocket 断开", error);
    if (this.isManuallyClosed) return;
    this.handleReconnect();
  };

  handleError = (error) => {
    console.error("websocket 错误:", error);
    if (this.isManuallyClosed) return;
    this.handleReconnect();
  };

  handleReconnect = () => {
    if (this.lockReconnect) return;
    this.lockReconnect = true;
    this.reconnectObj && clearTimeout(this.reconnectObj);
    this.reconnectObj = setTimeout(() => {
      this.reconnectAttempts++;
      console.log(
        "websocket 重连次数",
        this.reconnectAttempts,
        Math.floor(new Date().getTime() / 1000)
      );
      this.connect();
    }, this.reconnectInterval);
  };

  disconnect() {
    this.isManuallyClosed = true;
    this.heartbeatObj && clearInterval(this.heartbeatObj);
    this.serverHeartbeatObj && clearTimeout(this.serverHeartbeatObj);
    if (this.ws) {
      this.ws.close();
    }
  }
}

// 创建 WebSocketClient 实例
export const wsClient = new WebSocketClient();
